import { initEnv } from '@tencent/pmd-tools/lib/env';

/**
 * 根据场景添加adtag
 */
export function addAdtag(url) {
  const env = initEnv();
  if (env.isGHelper) {
    url = addQuery(url, 'adtag', 'ydsharechat');
  } else if (env.isQQ) {
    url = addQuery(url, 'adtag', 'qqsharechat');
  } else if (env.isWeixin) {
    url = addQuery(url, 'adtag', 'wxsharechat');
  }
  return url;
}

/**
 * 给url添加query参数
 */
export function addQuery(url, key, value) {
  if (url.indexOf('?') == -1) {
    return `${url}?${key}=${value}`;
  }
  return `${url}&${key}=${value}`;
}
